import React from 'react';

export default () => (
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.0005 19V3C15.0005 2.46957 14.7898 1.96086 14.4147 1.58579C14.0396 1.21071 13.5309 1 13.0005 1H9.00049C8.47006 1 7.96135 1.21071 7.58628 1.58579C7.2112 1.96086 7.00049 2.46957 7.00049 3V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
